/* @flow */

import type { Customer } from "shop-state/types";

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import useFormat from "helpers/use-format";
import cn from "classnames";

import styles from "components/AccountView/styles.scss";

type Props = {
  customer: Customer,
};

const ExpiringPoints = ({ customer }: Props): React$Node => {
  const t = useTranslate();
  const { memberPoints } = customer;
  const { formatPoints } = useFormat();

  return (
    <div className={cn("awardit-ExpiringPointsTable")}>
      <header className={styles.boxHeader}>
        <h2 className={styles.boxHeading}>{t("ACCOUNT.EXPIRES_HEADER")}</h2>
      </header>
      <section className={styles.boxBody}>
        <table className={cn(styles.pointsTable, styles.expiringPointsTable)}>
          <tbody>
            {memberPoints &&
            memberPoints.expirePoints &&
            memberPoints.expirePoints.length > 0 && (
              memberPoints.expirePoints.map((partner, i) => (
                <tr key={i}>
                  <td>{partner.partner}</td>
                  <td>{formatPoints(partner.points)}</td>
                  <td>{partner.date}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default ExpiringPoints;
